import { ASSIGMENTS_ORDER_DETAIL, ASSIGMENTS_ORDER_DETAIL_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const getOrderAssignmentDetail = (params) => async (dispatch) => {
  const { legal_id, order_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'get',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_DETAIL,
    });
  } catch (e) {
    dispatch({
      method: 'get',
      payload: e || {},
      type: ASSIGMENTS_ORDER_DETAIL_ERROR,
    });
  }
};
